"use client";

import { Box, Droplets, Leaf, Sun } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Capability() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const commitments = [{
    number: "01",
    Icon: Leaf,
    title: "We know social media matters, but we don't have time to do it properly.",
    description: "We know social media matters, but we don't have time to do it properly.\nWe have great stories to tell and important services to promote, but our team is stretched. We need help creating content, reaching new audiences and increasing awareness of what we do."
  }, {
    number: "02",
    Icon: Droplets,
    title: "Our website no longer reflects who we are",
    description: "The website was built years ago and hasn't kept pace with the organisation. We need help improving content, updating pages and creating a stronger digital presence."
  }, {
    number: "03",
    Icon: Sun,
    title: "We're being asked about sustainability, but don't know where to start.",
    description: "We already do lots of positive things, but they're not connected. We need help bringing our activities together into a simple framework that can support future funding and grant applications."
  }, {
    number: "04",
    Icon: Box,
    title: "Everyone is talking about AI. Where do we start?",
    description: "We're curious about AI but don't know where to begin. Could it help us save time, improve productivity, write funding applications, create content or reduce administration?"
  }];
  return <section data-section-id="4370" id="addressing-the-market-gap" className="bg-background text-foreground py-32 px-6 md:px-12">
      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        
        <div className="text-center mb-20 md:mb-28">
          
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] text-foreground !h-[48.383152px]">Some common challenges that charities discuss</h2>
        </div>

        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {commitments.map((item, i) => {
          const Icon = item.Icon;
          return <div key={i} data-index={i} className="group relative p-10 md:p-12 bg-muted border transition-colors duration-500 hover:bg-accent" style={{
            borderColor: "var(--border)"
          }}>
                
                <div className="font-serif italic text-5xl md:text-6xl font-light mb-6 transition-transform duration-500 group-hover:translate-x-1" style={{
              color: "var(--chart-1)",
              fontVariantNumeric: "tabular-nums"
            }}>
                  {item.number}
                </div>

                
                <div className="h-px w-12 mb-8 transition-all duration-700 ease-out group-hover:w-24" style={{
              backgroundColor: "var(--chart-1)"
            }} />

                
                <Icon className="h-12 w-12 mb-8 stroke-1" style={{
              color: "var(--chart-1)"
            }} strokeWidth={1} aria-hidden="true" />

                
                <h3 className="font-serif font-default text-2xl md:text-3xl font-light text-foreground mb-5 leading-tight">
                  {item.title}
                </h3>

                
                <p className="font-sans text-base leading-relaxed max-w-sm" style={{
              color: "var(--ink-secondary)"
            }}>
                  {item.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}